// material-ui
import { Stack, Grid, Skeleton } from '@mui/material';

// ==============================|| SKELETON - TABLE TOOLBAR ||============================== //

const SkeletonTableToolbar = () => (
    <Grid
        container
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent={{ xs: 'center', sm: 'space-between' }}
        alignItems="center"
        spacing={2}
    >
        <Grid item xs>
            <Skeleton variant="rectangular" width={100} height={28} sx={{ borderRadius: '2px' }} />
        </Grid>
        <Grid item>
            <Stack direction="row" spacing={2}>
                <Skeleton variant="rectangular" width={100} height={28} sx={{ borderRadius: '2px' }} />
                <Skeleton variant="rectangular" width={100} height={28} sx={{ borderRadius: '2px' }} />
                <Skeleton variant="rectangular" width={100} height={28} sx={{ borderRadius: '2px' }} />
                <Skeleton variant="rectangular" width={100} height={28} sx={{ borderRadius: '2px' }} />
            </Stack>
        </Grid>
    </Grid>
);

export default SkeletonTableToolbar;
